import { VerticalTimeline } from "react-vertical-timeline-component/dist-modules";
import VerticalTimelineElement from "react-vertical-timeline-component/dist-modules/VerticalTimelineElement";
import "react-vertical-timeline-component/style.min.css"

import { timelineData } from "./content/timelinedata";

import { ReactComponent as WorkIcon } from './css/Resources/work.svg';
import { ReactComponent as SchoolIcon } from './css/Resources/education.svg';

const timeline = () => {
    const forward = ['//'];
    let WorkIconStyles = {
        background: "white"
    }
    let schoolIconStyles = {
        background: "white"
    }
    let linecolor="#ff406d";

    return (
        <div className="Timeline">
            <h1>{forward}Timeline</h1>
            <VerticalTimeline lineColor={linecolor}>
                {
                    timelineData.map(element => {
                        let isworkicon = element.icon === "work";
                        let showButton = element.buttonText !== undefined && element.buttonText !== '' && element.buttonText !== null;

                        return (
                            <VerticalTimelineElement
                                key={element.key}
                                date={element.date}
                                dateClassName="Timeline_date"
                                iconStyle={isworkicon ? WorkIconStyles : schoolIconStyles}
                                icon={isworkicon ? <WorkIcon /> : <SchoolIcon />}
                            >
                                <h3 className="vertical-timeline-element-title">
                                    {element.title}
                                </h3>

                                <h4 className="vertical-timeline-element-subtitle">
                                    {element.location}
                                </h4>

                                <p className="description">
                                    {element.description}
                                </p>

                                {showButton && (
                                    <a href={element.link} className={`Button ${isworkicon ? "workbutton" : "schoolbutton"}`}> {element.buttonText}</a>
                                )}
                            </VerticalTimelineElement>
                        )
                    }
                    )
                }
            </VerticalTimeline>
        </div>
    );
}

export default timeline;